import { SkullIcon, TrashIcon } from "@phosphor-icons/react";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from "./ui/dropdown-menu";
import { useTrash } from "../lib/useTrash";

export const TRASH_REASONS = [
  { id: "newbie_trap", label: "Newbie trap", emoji: "🪤", hint: "Fake token copying a real brand to fool beginners" },
  { id: "rug", label: "Rug pull", emoji: "💧", hint: "Liquidity pulled / honeypot" },
  { id: "dev_dumped", label: "Dev dumped", emoji: "📉", hint: "Creator sold their supply" },
  { id: "fake_volume", label: "Fake volume / bots", emoji: "🤖", hint: "Wash-traded, not real demand" },
  { id: "dead", label: "Dead project", emoji: "🕸️", hint: "No activity / dead site" },
  { id: "trash", label: "Just trash", emoji: "🗑️", hint: "Low quality / not worth it" },
];

export const reasonMeta = (id) => TRASH_REASONS.find((r) => r.id === id) || null;

// Skull button. When not trashed, opens a reason picker. When trashed, one click restores.
export const TrashButton = ({ mint, symbol, testid, size = 15, className = "", icon = "skull" }) => {
  const { isTrashed, trash, untrash } = useTrash();
  const trashed = isTrashed(mint);
  const Icon = icon === "trash" ? TrashIcon : SkullIcon;

  if (trashed) {
    return (
      <button
        onClick={(e) => { e.stopPropagation(); untrash(mint); }}
        title="Restore token"
        data-testid={testid}
        className={`p-1.5 transition-colors hover:text-white ${className}`}
      >
        <Icon size={size} weight="fill" color="#FF3366" />
      </button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          onClick={(e) => e.stopPropagation()}
          title="Mark as trash/scam — pick a reason"
          data-testid={testid}
          className={`p-1.5 transition-colors hover:text-danger text-[#666] ${className}`}
        >
          <Icon size={size} weight={icon === "trash" ? "regular" : "bold"} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56 bg-[#0b0d10] border-white/15 z-[80]">
        <DropdownMenuLabel className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground">
          Why is ${symbol || "this"} trash?
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-white/10" />
        {TRASH_REASONS.map((r) => (
          <DropdownMenuItem
            key={r.id}
            data-testid={`${testid}-reason-${r.id}`}
            onClick={(e) => { e.stopPropagation(); trash(mint, symbol, r.id); }}
            className="flex flex-col items-start gap-0.5 cursor-pointer focus:bg-danger/15 focus:text-white py-2"
          >
            <span className="flex items-center gap-2 text-sm font-semibold">{r.emoji} {r.label}</span>
            <span className="text-[10px] text-muted-foreground leading-tight">{r.hint}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
